import { sv } from 'date-fns/locale';
import {
	formatDistanceStrict as dateFormatDistanceStrictInternal,
	format as dateFormatInternal
} from 'date-fns';

// Set language
let localeFile;

setLocale(window?.js_params?.module?.LanguageSelector?.languageSelected || 'sv');

export async function setLocale (locale) {
	localeFile = await getLocale(locale);
}

async function getLocale (locale) {
	switch (locale) {
		case 'en': {
			const { enGB } = await import('date-fns/locale/en-GB');
			return enGB;
		}
		case 'sv':
			// You already imported this statically at the top
			return sv;
		case 'da': {
			const { da } = await import('date-fns/locale/da');
			return da;
		}
		case 'de': {
			const { de } = await import('date-fns/locale/de');
			return de;
		}
		case 'no': {
			const { nb } = await import('date-fns/locale/nb');
			return nb;
		}
		case 'fr': {
			const { fr } = await import('date-fns/locale/fr');
			return fr;
		}
		case 'fi': {
			const { fi } = await import('date-fns/locale/fi');
			return fi;
		}
		default: {
			const { enGB } = await import('date-fns/locale/en-GB');
			return enGB;
		}
	}
}

export function dateFormat (date, formatStyle) {
	return removeDotFromString(dateFormatInternal(date, formatStyle, { locale: localeFile }));
}

export function dateFormatYMD (date) {
	return removeDotFromString(dateFormat(date, 'yyyy-MM-dd'));
}

export function dateFormatDistanceStrict (date, baseDate, options) {
	return removeDotFromString(dateFormatDistanceStrictInternal(date, baseDate, { ...options, locale: localeFile }));
}

export {
	add as dateAdd,
	addDays as dateAddDays,
	addMinutes as dateAddMinutes,
	addMonths as dateAddMonths,
	addWeeks as dateAddWeeks,
	addHours as dateAddHours,
	differenceInDays as dateDifferenceInDays,
	formatDistance as dateFormatDistance,
	getDate as dateGetDate,
	getDay as dateGetDay,
	getHours as dateGetHours,
	getISOWeek as dateGetISOWeek,
	getMinutes as dateGetMinutes,
	getMonth as dateGetMonth,
	getSeconds as dateGetSeconds,
	getYear as dateGetYear,
	isAfter as dateIsAfter,
	isBefore as dateIsBefore,
	isPast as dateIsPast,
	isSameDay as dateIsSameDay,
	isThisHour as dateIsThisHour,
	isToday as dateIsToday,
	isWeekend as dateIsWeekend,
	parseISO as dateParseISO,
	set as dateSet,
	subDays as dateSubDays,
	subHours as dateSubHours,
	startOfDay as dateStartOfDay
} from 'date-fns';


/**
 *
 * @param {String} str
 * @returns {String}
 */
function removeDotFromString (str) {
	return str.replace(/\./g, '');
}
